// extracted by mini-css-extract-plugin
module.exports = {"container":"Detail_container__2lW3D","table":"Detail_table__3OKdj","row":"Detail_row__2PAld","headerRow":"Detail_headerRow__3kqNI","header":"Detail_header__12Boh"};